export default __webpack_public_path__ + "static/media/servicesGroomMob.3906ad55.jpg";